module.exports = __webpack_public_path__ + "static/media/challenge-background-init-flowers.6f3cb256.svg";